// HealthcheckPage.tsx
import { Heading2 } from "components";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { useHealthcheck } from "hooks/useHealthCheck";
import { useSSLCheck } from "hooks/useSSLCheck";
import { useRhCheck } from "hooks/useRhCheck";
import { useDbHealthCheck } from "hooks/useDbHealthCheck";

const PageWrapper = styled.div`
  font-family: sans-serif;
`;

const Title = styled(Heading2)`
  margin-bottom: 1.5rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1rem;
`;

const Card = styled.div<{ status: "ok" | "warning" | "error" }>`
  background: white;
  padding: 1rem;
  border-left: 5px solid
    ${({ status }) =>
      status === "ok" ? "green" : status === "warning" ? "orange" : "red"};
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
`;

const ServiceName = styled.div`
  font-weight: bold;
`;

const StatusText = styled.div`
  margin-top: 0.25rem;
  font-size: 0.9rem;
  color: #666;
`;

const Timestamp = styled.div`
  margin-top: 2rem;
  font-size: 0.85rem;
  color: #888;
`;

const Button = styled.a`
  margin-top: 1.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  background-color: #007acc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  &:hover {
    color: white;
  }
`;

const HealthCheck = () => {
  const apiStatus = useHealthcheck();
  const sslStatus = useSSLCheck();
  const rhStatus = useRhCheck();
  const dbStatus = useDbHealthCheck();

  const [timestamp, setTimestamp] = useState("");


  const services = [
    {
      name: "API Interna", status: apiStatus
    },
    { name: "Base de datos", status: dbStatus },
    { name: "Certificado de seguridad", status: sslStatus },
    { name: "API Externa (Recursos Humanos)", status: rhStatus },
    { name: "Servicio de correo", status: "ok" },
  ] as const;

  useEffect(() => {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "America/Costa_Rica",
    };

    const formatted = now
      .toLocaleString("es-CR", options)
      .replace(",", "")
      .replace(".", ""); // Limpia formatos innecesarios

    setTimestamp(formatted);
  }, []);

  return (
    <PageWrapper>
      <Title>Estado del Sistema</Title>
      <Grid>
        {services.map((service, index) => (
          <Card key={index} status={service.status}>
            <ServiceName>{service.name}</ServiceName>
            <StatusText>
              {service.status === "ok"
                ? "✅ Operativo"
                : service.status === "warning"
                ? "⚠️ Parcialmente operativo"
                : "❌ No disponible"}
            </StatusText>
          </Card>
        ))}
      </Grid>
      <Timestamp>Última actualización: {timestamp}</Timestamp>
      <Button href="/matricula/login">Volver a la página principal</Button>
    </PageWrapper>
  );
};

export default HealthCheck;
